import { createContext, useContext, useMemo, useState } from "react";

import Service from "../api/service";

const InfoContext = createContext(null);

export const useInfoContext = () => {
  const v = useContext(InfoContext);
  if (!v) {
    throw new Error("useInfoContext must be used inside InfoProvider");
  }
  return v;
};

export const InfoProvider = ({ children }) => {
  const [contacts, setContacts] = useState(null);
  const [about, setAbout] = useState(null);
  const [count, setCount] = useState(0);

  const updateInfoState = async (next) => setContacts(next);

  const fetchContacts = async (page = 1, pageSize = 50) => {
    const response = await Service.get(
      `/api/v1/contact/?page=${page}&pageSize=${pageSize}`,
    );
    const payload = response?.data;
    if (payload) {
      setContacts(payload.data);
      setCount(payload.count);
    }
    return response;
  };

  const fetchAbout = async () => {
    const response = await Service.get("/api/v1/about");
    setAbout(response?.data ?? null);
    return response;
  };

  const updateAbout = async (about_us_id, payload) =>
    Service.put(`/api/v1/about/${about_us_id}`, payload);

  const updateContact = async (contact_us_id, payload) =>
    Service.put(`/api/v1/contact/${contact_us_id}`, payload);

  const value = useMemo(
    () => ({
      about,
      contacts,
      count,
      fetchAbout,
      fetchContacts,
      updateAbout,
      updateContact,
      updateInfoState,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [about, contacts, count],
  );

  return <InfoContext.Provider value={value}>{children}</InfoContext.Provider>;
};
